export const projects = [
	{
		img: '/signup.JPG',
		title: 'User Signup and Login',
		des: 'User Signup, Login, Forgot Password and Profile pages with backend in Nodejs',
		demo: '',
		live: 'https://subtle-creponne-3f1ac9.netlify.app/',
		gitHub: 'https://github.com/Masrur00/user_credential',
		technologies: ['Nodejs', 'React', 'Redux', 'HTML', 'CSS', 'javaScript'],
	},
	{
		img: "/dermstore.PNG",
		title: "Dermstore",
		des:  "A web application for buying & selling of Skin & Hair oil products.",
		demo: '',
		live: "https://dermstore-clone-masai.netlify.app/",
		gitHub: "https://github.com/Raju-16/glistening-salt-6402",
		technologies: ['React', 'Redux', 'HTML', 'CSS', 'javaScript'],
	},
	{
		img: "/meesho2.PNG",
		title: "Meesho Clone",
		des:  "A web application for buying & selling of Clothes.",
		demo: '',
		live: "https://meesho-replica.netlify.app/index.html",
		gitHub: "https://github.com/tanviSAM/Meesho-Clone",
		technologies: ['HTML', 'CSS', 'javaScript','Api'],
	},
	{
		img: "/flatheads.JPG",
		title: 'Flat-Heads Clone',
		des: "A web application to buy any type of slipper products.",
		demo: '',
		live: "https://flatheads-clone-gamma.vercel.app/",
		gitHub: "https://github.com/Duwesh/Flatheads-Clone",
		technologies: ['HTML', 'CSS', 'javaScript'],
	},
	
	
];
